// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsUMtmYAggtleks1YGtL {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  height: 105px;
  /* Equal 5px margin on top/bottom/left for the 95×95 thumbnail inside the
     105px tall card: (105 - 95) / 2 = 5. Right kept tighter to give info
     column extra room (Figma's 12px right padding assumes 96px thumbnail). */
  padding: 5px 4.5px 5px 5px;
  box-sizing: border-box;
  border: 1.5px solid #3f3f3f;
  border-radius: 15px;
  background: var(--grey-menu, #313131);
  backdrop-filter: blur(15px);
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.7), 0 0 1.5px 0 #000;
  cursor: pointer;
}
.lsUMtmYAggtleks1YGtL[data-loading] {
  cursor: wait;
}
/* Play button overlay — hidden by default, shown on hover (desktop). */
.EJriohmKuMGxFbiGbeLw {
  display: none;
}
@media (hover: hover) and (pointer: fine) {
  .lsUMtmYAggtleks1YGtL:hover .Dec1ffcKfOXLU45wtHtw {
    visibility: hidden;
  }
  .lsUMtmYAggtleks1YGtL:hover .EJriohmKuMGxFbiGbeLw {
    display: flex;
  }
  .lsUMtmYAggtleks1YGtL:hover::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.75);
    border-radius: inherit;
    z-index: 1;
    pointer-events: none;
  }
}
@media (hover: none) and (pointer: coarse) {
  .lsUMtmYAggtleks1YGtL:hover .Dec1ffcKfOXLU45wtHtw {
    visibility: visible !important;
  }
  .lsUMtmYAggtleks1YGtL:hover .EJriohmKuMGxFbiGbeLw {
    display: none !important;
  }
  .lsUMtmYAggtleks1YGtL:hover::before {
    display: none !important;
  }
}
.MrAhMSQcRtQSLuuKVOMg {
  position: relative;
  flex-shrink: 0;
  /* Fill the card's content area vertically (= card height − vertical padding);
     width follows the 58:64 portrait ratio from Figma (not square). Keeps
     top/bottom/left thumbnail margins equal to the card's padding at any
     card height. */
  height: 100%;
  aspect-ratio: 58 / 64;
  border-radius: 10px;
  overflow: hidden;
  background: #222;
}
.tw1O3EPBXvSg6fveDQwC {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* 120% (not 100%) so object-fit: cover crops from a taller box — shifts the
     visible crop toward the top of the game art instead of vertical-center.
     The overflow is clipped by .thumbnail's overflow: hidden. */
  height: 120%;
  object-fit: cover;
  display: block;
}
.Dec1ffcKfOXLU45wtHtw {
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  height: 75px;
  margin-right: 5px;
  /* Theme the shared <TopWinAmount> (see TopWinAmount.module.css). Left-aligned,
     ghost-white, nudged up 3px to match the Figma amount-row baseline. */
  --tw-amount-clip: 30px;
  --tw-amount-size: 30px;
  --tw-amount-color: var(--ghost-white-color, #f9f9f9);
  --tw-amount-justify: flex-start;
  --tw-amount-origin: left center;
  --tw-amount-offset-y: -3px;
}
.W7yfWu1zabau8D5jD9JS {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  height: 15px;
  transform: translateY(-7px);
}
.RjkEropdHxWRsjBCGjnB {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  font-family: var(--font-family-primary);
  font-weight: 400;
  font-size: 18px;
  color: #fff;
  white-space: nowrap;
  /* line-height: normal (driven by font metrics, ~1.15–1.2) so the
     line-box has room for descenders (g, p, q, y, j) which extend below
     the baseline by ~20–25 % of em. Lower values (1.0, Figma's 0.76)
     would clip those tails because overflow:hidden — needed for
     text-overflow:ellipsis — also clips vertically. align-items:baseline
     on .meta keeps the glyph baseline locked to timeAgo regardless of
     line-height. */
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v5iCeJ4Vvxc10Vp9Ml0g {
  display: block;
  flex: 0 0 auto;
  margin-left: 8px;
  font-family: var(--font-family-primary);
  font-style: italic;
  font-size: 18px;
  color: #fff;
  white-space: nowrap;
  line-height: 0.95;
}
/* Compact card (≤1025px) — aligned with the section/featured-card breakpoint
   where regular game cards switch from 246px (desktop) down to 164px. */
@media (max-width: 1025px) {
  .lsUMtmYAggtleks1YGtL {
    height: 100%;
    padding: 3px;
    gap: 4px;
    border-width: 1px;
    border-radius: 10px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.7), 0 0 1px 0 #000;
    backdrop-filter: blur(10px);
  }
  .MrAhMSQcRtQSLuuKVOMg {
    border-radius: 7px;
  }
  .Dec1ffcKfOXLU45wtHtw {
    height: 50px;
    gap: 8px;
    /* Compact amount: 20px, and no vertical nudge (desktop's -3px not needed). */
    --tw-amount-clip: 20px;
    --tw-amount-size: 20px;
    --tw-amount-offset-y: 0px;
  }
  .W7yfWu1zabau8D5jD9JS {
    height: 10px;
    transform: translateY(-5px);
  }
  .RjkEropdHxWRsjBCGjnB {
    font-size: 12px;
  }
  .v5iCeJ4Vvxc10Vp9Ml0g {
    font-size: 12px;
  }
}
/* Mobile portrait only (≤500px) — small card. Height comes from the
   slot's --top-wins-card-height (derived from featured width), so the
   card fills the slot at every viewport in this range. */
@media (max-width: 500px) {
  .lsUMtmYAggtleks1YGtL {
    padding: 3px;
    border-width: 1px;
    border-radius: 10px;
    gap: 8px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.7), 0 0 1px 0 #000;
    backdrop-filter: blur(10px);
  }
  .MrAhMSQcRtQSLuuKVOMg {
    border-radius: 7px;
  }
  /* Stretch info to fill the card content area (= card-h − padding) instead of
     a fixed 49px. Between 375–500 the card-h is driven by 34.2vw featured
     width, so it lands on fractional pixels (e.g. 53.57 at 375). A fixed info
     height that exceeds the content area gets items-center'd inside the card,
     leaving the info top on a sub-pixel offset (≈2.285) — different from the
     thumbnail top (= padding = 3) — and the slot-1 card's amount lands on a
     pixel boundary that rounds toward clipping. Stretching aligns info top
     with thumbnail top and snaps both to the padding edge. */
  .Dec1ffcKfOXLU45wtHtw {
    align-self: stretch;
    height: auto;
    gap: 8px;
  }
  /* amount-clip / stack / leading inherited from the ≤1279px block — same
     20px font, same Figma amount-row spec (15 / 18 / 13.386). */
}
`, "",{"version":3,"sources":["webpack://./src/features/topWins/components/TopWinCard/TopWinCard.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,aAAa;EACb;;6EAE2E;EAC3E,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,0DAA0D;EAC1D,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA,uEAAuE;AACvE;EACE,aAAa;AACf;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,sBAAsB;IACtB,UAAU;IACV,oBAAoB;EACtB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;EACd;;;mBAGiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX;;gEAE8D;EAC9D,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB;yEACuE;EACvE,sBAAsB;EACtB,sBAAsB;EACtB,oDAAoD;EACpD,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB;;;;;;mBAMiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA;wEACwE;AACxE;EACE;IACE,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,wDAAwD;IACxD,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,QAAQ;IACR,6EAA6E;IAC7E,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;;yDAEyD;AACzD;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,wDAAwD;IACxD,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;EACA;;;;;;;6DAO2D;EAC3D;IACE,mBAAmB;IACnB,YAAY;IACZ,QAAQ;EACV;EACA;gEAC8D;AAChE","sourcesContent":[".card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  height: 105px;\n  /* Equal 5px margin on top/bottom/left for the 95×95 thumbnail inside the\n     105px tall card: (105 - 95) / 2 = 5. Right kept tighter to give info\n     column extra room (Figma's 12px right padding assumes 96px thumbnail). */\n  padding: 5px 4.5px 5px 5px;\n  box-sizing: border-box;\n  border: 1.5px solid #3f3f3f;\n  border-radius: 15px;\n  background: var(--grey-menu, #313131);\n  backdrop-filter: blur(15px);\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.7), 0 0 1.5px 0 #000;\n  cursor: pointer;\n}\n.card[data-loading] {\n  cursor: wait;\n}\n/* Play button overlay — hidden by default, shown on hover (desktop). */\n.playButton {\n  display: none;\n}\n@media (hover: hover) and (pointer: fine) {\n  .card:hover .info {\n    visibility: hidden;\n  }\n  .card:hover .playButton {\n    display: flex;\n  }\n  .card:hover::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.75);\n    border-radius: inherit;\n    z-index: 1;\n    pointer-events: none;\n  }\n}\n@media (hover: none) and (pointer: coarse) {\n  .card:hover .info {\n    visibility: visible !important;\n  }\n  .card:hover .playButton {\n    display: none !important;\n  }\n  .card:hover::before {\n    display: none !important;\n  }\n}\n.thumbnail {\n  position: relative;\n  flex-shrink: 0;\n  /* Fill the card's content area vertically (= card height − vertical padding);\n     width follows the 58:64 portrait ratio from Figma (not square). Keeps\n     top/bottom/left thumbnail margins equal to the card's padding at any\n     card height. */\n  height: 100%;\n  aspect-ratio: 58 / 64;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #222;\n}\n.thumbnailImg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  /* 120% (not 100%) so object-fit: cover crops from a taller box — shifts the\n     visible crop toward the top of the game art instead of vertical-center.\n     The overflow is clipped by .thumbnail's overflow: hidden. */\n  height: 120%;\n  object-fit: cover;\n  display: block;\n}\n.info {\n  display: flex;\n  flex: 1 0 0;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 12px;\n  height: 75px;\n  margin-right: 5px;\n  /* Theme the shared <TopWinAmount> (see TopWinAmount.module.css). Left-aligned,\n     ghost-white, nudged up 3px to match the Figma amount-row baseline. */\n  --tw-amount-clip: 30px;\n  --tw-amount-size: 30px;\n  --tw-amount-color: var(--ghost-white-color, #f9f9f9);\n  --tw-amount-justify: flex-start;\n  --tw-amount-origin: left center;\n  --tw-amount-offset-y: -3px;\n}\n.meta {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  width: 100%;\n  height: 15px;\n  transform: translateY(-7px);\n}\n.gameName {\n  display: block;\n  flex: 1 1 auto;\n  min-width: 0;\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  font-size: 18px;\n  color: #fff;\n  white-space: nowrap;\n  /* line-height: normal (driven by font metrics, ~1.15–1.2) so the\n     line-box has room for descenders (g, p, q, y, j) which extend below\n     the baseline by ~20–25 % of em. Lower values (1.0, Figma's 0.76)\n     would clip those tails because overflow:hidden — needed for\n     text-overflow:ellipsis — also clips vertically. align-items:baseline\n     on .meta keeps the glyph baseline locked to timeAgo regardless of\n     line-height. */\n  line-height: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.timeAgo {\n  display: block;\n  flex: 0 0 auto;\n  margin-left: 8px;\n  font-family: var(--font-family-primary);\n  font-style: italic;\n  font-size: 18px;\n  color: #fff;\n  white-space: nowrap;\n  line-height: 0.95;\n}\n/* Compact card (≤1025px) — aligned with the section/featured-card breakpoint\n   where regular game cards switch from 246px (desktop) down to 164px. */\n@media (max-width: 1025px) {\n  .card {\n    height: 100%;\n    padding: 3px;\n    gap: 4px;\n    border-width: 1px;\n    border-radius: 10px;\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.7), 0 0 1px 0 #000;\n    backdrop-filter: blur(10px);\n  }\n  .thumbnail {\n    border-radius: 7px;\n  }\n  .info {\n    height: 50px;\n    gap: 8px;\n    /* Compact amount: 20px, and no vertical nudge (desktop's -3px not needed). */\n    --tw-amount-clip: 20px;\n    --tw-amount-size: 20px;\n    --tw-amount-offset-y: 0px;\n  }\n  .meta {\n    height: 10px;\n    transform: translateY(-5px);\n  }\n  .gameName {\n    font-size: 12px;\n  }\n  .timeAgo {\n    font-size: 12px;\n  }\n}\n/* Mobile portrait only (≤500px) — small card. Height comes from the\n   slot's --top-wins-card-height (derived from featured width), so the\n   card fills the slot at every viewport in this range. */\n@media (max-width: 500px) {\n  .card {\n    padding: 3px;\n    border-width: 1px;\n    border-radius: 10px;\n    gap: 8px;\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.7), 0 0 1px 0 #000;\n    backdrop-filter: blur(10px);\n  }\n  .thumbnail {\n    border-radius: 7px;\n  }\n  /* Stretch info to fill the card content area (= card-h − padding) instead of\n     a fixed 49px. Between 375–500 the card-h is driven by 34.2vw featured\n     width, so it lands on fractional pixels (e.g. 53.57 at 375). A fixed info\n     height that exceeds the content area gets items-center'd inside the card,\n     leaving the info top on a sub-pixel offset (≈2.285) — different from the\n     thumbnail top (= padding = 3) — and the slot-1 card's amount lands on a\n     pixel boundary that rounds toward clipping. Stretching aligns info top\n     with thumbnail top and snaps both to the padding edge. */\n  .info {\n    align-self: stretch;\n    height: auto;\n    gap: 8px;\n  }\n  /* amount-clip / stack / leading inherited from the ≤1279px block — same\n     20px font, same Figma amount-row spec (15 / 18 / 13.386). */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `lsUMtmYAggtleks1YGtL`,
	"playButton": `EJriohmKuMGxFbiGbeLw`,
	"info": `Dec1ffcKfOXLU45wtHtw`,
	"thumbnail": `MrAhMSQcRtQSLuuKVOMg`,
	"thumbnailImg": `tw1O3EPBXvSg6fveDQwC`,
	"meta": `W7yfWu1zabau8D5jD9JS`,
	"gameName": `RjkEropdHxWRsjBCGjnB`,
	"timeAgo": `v5iCeJ4Vvxc10Vp9Ml0g`
};
export default ___CSS_LOADER_EXPORT___;
